import { style } from '@vanilla-extract/css'
import { vars } from '~/styles/theme.css'

export const requirementsList = style({
  columnCount: 2,
  columnGap: 20,
  margin: 0,
  paddingLeft: 20,
  fontSize: 11,
  fontWeight: 700,
  lineHeight: 1.5
})

export const requirementNok = style({
  color: vars.color.dark,
  opacity: 0.3
})

export const requirementOk = style({
  color: vars.color.dark
})
